import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Typography, Divider } from '@mui/material';
import { useAlert } from '../../../components/Notification';
import { EmailInput, PasswordInput } from '../../../components/TextFields';

import { handleLogin } from '../../../stores/services/authApis/index';
import { setLoginAction } from '../../../stores/actionTypes/authActions/index';

import { hashPassword } from '../../../constant/constant';

const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isEmailValid, setisEmailValid] = useState(false);
  const [isPasswordValid, setisPasswordValid] = useState(false);
  const showAlert = useAlert();

  const login = async () => {
    await handleLogin({ username: email, password: hashPassword(password) })
      .then((response) => {
        const { error, data } = response.data;
        if (error) {
          showAlert('Invalid credential', 'error');
          return;
        }
        showAlert('Login Successfully', 'success');
        localStorage.setItem('ICEMAKE', data);
        dispatch(setLoginAction(data));
        navigate('/equipment/ownedequipment');
      })
      .catch(() => {
        showAlert('Invalid credential', 'error');
      });
  };

  return (
    <>
      <div className="form_header">
        <Typography variant="h5" align="center" fontWeight="bold">
          Sign In
        </Typography>
      </div>
      <div className="auth_form">
        <div className="auth_formitem">
          <div className="form-input">
            <EmailInput
              value={email}
              handleValid={setisEmailValid}
              onChange={setEmail}
              error={isEmailValid}
            />
          </div>
          <div className="form-input">
            <PasswordInput
              value={password}
              handleValid={setisPasswordValid}
              onChange={setPassword}
              error={isPasswordValid}
            />
          </div>
          <Typography variant="body2" align="right">
            <RouterLink className="routerLink" to="/forgot-password">
              Forgot Password?
            </RouterLink>
          </Typography>
        </div>

        <Divider component="div" role="presentation" />
        <div className="auth_formitem">
          <button
            name="submit"
            className="submit_Button"
            color="primary"
            disabled={!(isEmailValid && isPasswordValid)}
            onClick={() => login()}
          >
            Sign In
          </button>
          {/* <Typography
            variant="body2"
            align="center"
            className='submit_Button-text'
          >
            Don&rsquo;t have an account?{' '}
            <RouterLink className="routerLink" to="/signup">
              Sign up now
            </RouterLink>
          </Typography> */}
        </div>
      </div>
    </>
  );
};

export default connect((assets) => assets, {
  handleLogin,
})(SignIn);
